/**
 * TODO - convert to zod and move to @qualifio/api-client
 */
import qs from 'qs';
import joi, { Schema, ValidationError } from 'joi';
import { Cursor } from '@qualifio/api-client';
import { base64Decode, base64Encode } from '../utils';
import { joiOptions } from '../utils/joi/options';

export enum CursorDirection {
  BACKWARD = 'BACKWARD',
  FORWARD = 'FORWARD',
}

export interface CursorStr<T> {
  startId?: number;
  direction?: CursorDirection;
  filter: T;
}

export const $cursor = (filterSchema: Schema) =>
  joi
    .object<CursorStr<any>>({
      startId: joi.number().optional().empty(''),
      direction: joi
        .string()
        .valid(...Object.values(CursorDirection))
        .optional()
        .empty('')
        .default(CursorDirection.FORWARD),
      filter: filterSchema,
    })
    .required();

export class CursorError extends Error {
  constructor(message: string, public details: any) {
    super(message);
  }
}

export function toCursor<T>(data: CursorStr<T>) {
  const query = qs.stringify(data);
  return base64Encode(query);
}

export function parseCursor<T>(cursor: string, $filter: Schema<T>): CursorStr<T> {
  const decoded = base64Decode(cursor);
  const query: any = qs.parse(decoded);
  const validation = $cursor($filter).validate(query, joiOptions);
  if (validation.error) {
    throw new CursorError('Invalid cursor token', (validation.error as ValidationError).details);
  }

  return validation.value as CursorStr<T>;
}

export const emptyCursor: (pageSize: number) => Cursor<any> = (pageSize: number) => ({
  type: 'cursor',
  data: [],
  isLast: true,
  pageSize,
  direction: CursorDirection.FORWARD,
});
